const DEFAULT_DATA = {
    hero: {
        badge: 'ISO 27001 UYUMLU',
        badge_en: 'ISO 27001 COMPLIANT',
        title: 'Veri ve Bilgi Varlığı Yönetimi',
        title_en: 'Data and Information Asset Management',
        description:
            'Bilgi varlıkları ve veritabanları için kapsamlı yönetim çözümü. ISO 27001 standartlarına uygun sınıflandırma, izleme ve koruma ile verilerinizin güvenliğini tam kontrol altına alın.',
        description_en:
            'A comprehensive management solution for information assets and databases. Take full control of your data security with classification, monitoring, and protection compliant with ISO 27001 standards.',
        primaryButtonText: 'Şimdi Keşfedin',
        primaryButtonText_en: 'Explore Now',
        secondaryButtonText: 'Dokümantasyon',
        secondaryButtonText_en: 'Documentation',
        image: null,
    },

    stats: {
        stats: [
            {
                label: 'Toplam Varlık',
                label_en: 'Total Assets',
                value: '1,240',
                value_en: '1,240',
                trend: '+12% Bu Ay',
                trend_en: '+12% This Month',
                icon: 'layers',
            },
            {
                label: 'Sınıflandırma Oranı',
                label_en: 'Classification Rate',
                value: '%100',
                value_en: '100%',
                trend: 'Tam Uyum',
                trend_en: 'Full Compliance',
                icon: 'verified',
            },
            {
                label: 'Bütünlük Skoru',
                label_en: 'Integrity Score',
                value: '98.4',
                value_en: '98.4',
                trend: '+2.1% Artış',
                trend_en: '+2.1% Increase',
                icon: 'security',
            },
            {
                label: 'Kritik Uyarılar',
                label_en: 'Critical Alerts',
                value: '0',
                value_en: '0',
                trend: 'Güvenli Durum',
                trend_en: 'Secure Status',
                icon: 'warning',
            },
        ],
    },

    grid: {
        title: 'Veri Sınıflandırma',
        title_en: 'Data Classification',
        description: 'Erişim kontrolü ve güvenlik politikaları için seviyeler.',
        description_en: 'Levels for access control and security policies.',
        classificationList: [
            {
                label: 'Kamuya Açık',
                label_en: 'Public',
                count: '320 Varlık',
                count_en: '320 Assets',
                color: '#60a5fa',
            },
            {
                label: 'Kurum İçi',
                label_en: 'Internal',
                count: '684 Varlık',
                count_en: '684 Assets',
                color: '#4ade80',
            },
            {
                label: 'Gizli',
                label_en: 'Confidential',
                count: '186 Varlık',
                count_en: '186 Assets',
                color: '#facc15',
            },
            {
                label: 'Çok Gizli',
                label_en: 'Top Secret',
                count: '50 Varlık',
                count_en: '50 Assets',
                color: '#f87171',
            },
        ],
        features: [
            {
                icon: 'map',
                Title: 'Veri Akış Haritalama',
                Title_en: 'Data Flow Mapping',
                Description:
                    'Verilerinizin kurum içindeki hareketini görselleştirin ve sızıntı noktalarını önceden tespit edin.',
                Description_en:
                    'Visualize the movement of your data within the organization and proactively detect potential leak points.',
            },
            {
                icon: 'verified_user',
                Title: 'Bütünlük Koruması',
                Title_en: 'Integrity Protection',
                Description:
                    'Veri bütünlüğünü sağlamak için hash kontrolü ve kriptografik doğrulama araçlarını kullanın.',
                Description_en:
                    'Use hash verification and cryptographic validation tools to ensure data integrity.',
            },
            {
                icon: 'monitor_heart',
                Title: 'Erişilebilirlik İzleme',
                Title_en: 'Availability Monitoring',
                Description:
                    'Kritik veritabanlarınızın uptime oranlarını ve performans metriklerini 7/24 takip edin.',
                Description_en:
                    'Monitor the uptime rates and performance metrics of your critical databases 24/7.',
            },
            {
                icon: 'fact_check',
                Title: 'Uyum Denetimi',
                Title_en: 'Compliance Auditing',
                Description:
                    'ISO 27001 denetimleri için tek tıkla varlık envanteri ve risk raporları oluşturun.',
                Description_en:
                    'Generate asset inventory and risk reports with a single click for ISO 27001 audits.',
            },
        ],
    },

    table: {
        title: 'Varlık Envanteri',
        title_en: 'Asset Inventory',
        rows: [
            {
                name: 'Müşteri Veritabanı (SQL)',
                name_en: 'Customer Database (SQL)',
                type: 'Veritabanı',
                type_en: 'Database',
                classification: 'ÇOK GİZLİ',
                classification_en: 'TOP SECRET',
            },
            {
                name: 'İK Personel Dosyaları',
                name_en: 'HR Personnel Files',
                type: 'Bilgi Varlığı',
                type_en: 'Information Asset',
                classification: 'GİZLİ',
                classification_en: 'CONFIDENTIAL',
            },
            {
                name: 'Genel Kurumsal Dokümanlar',
                name_en: 'General Corporate Documents',
                type: 'Doküman',
                type_en: 'Document',
                classification: 'KURUM İÇİ',
                classification_en: 'INTERNAL',
            },
        ],
    },
};

export default DEFAULT_DATA;